///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.three_pm_import = abcsetup.three_pm_import || {};
abcsetup.three_pm_import.manage_images = abcsetup.three_pm_import.manage_images || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.three_pm_import.manage_images = {
    init: function() {

        // Remove image button clicked
        $(document).on('click', 'button.remove-image', function (event) {
            const _this = $(this);
            abcsetup.alerts.confirm('Delete Image', 'Are you sure you want to delete this image?', function (resp) {
                if (!resp) {
                    return;
                }
                var image = _this.data('id');
                abcsetup.three_pm_import.manage_images._removeImage(image, event);
                return false;
            });
        });
    },
    /**
     * Remove the item image
     */
    _removeImage: function (image) {
        console.log('Removing', 'Image: ' + image);
        axios.post('/api/three_pm_import/remove_image/' + image).then(response => {
           // show message image removed
            if ( response.data.image ) {
                if ( response.data.message_type == "danger" ) {
                    // remove message is shown in a danger message
                    abcsetup.alerts.flashMessage((response.data.message_text ? response.data.message_text : 'Error'), (response.data.message_type ? response.data.message_type : 'warning'), false);
                    $("div[data-image='"+response.data.image+"']").remove();
                } else {
                    abcsetup.alerts.flashMessage((response.data.message_text ? response.data.message_text : 'Error') + ' (' + (response.data.image ? response.data.image : 'NaN') + ')', (response.data.message_type ? response.data.message_type : 'warning'), false);
                }
            } else {
                abcsetup.alerts.flashMessage('An Unknown Error Occurred', 'warning', false);
            }
        });
    },
}
